import { AccountRelationshipType, RelationshipType } from 'graphql/bindings/AdminBindings'

export const isIntroduction = (relationshipType: RelationshipType): boolean =>
  [RelationshipType.Introduced, RelationshipType.WasIntroducedBy].includes(relationshipType)

export const displayRelationshipType = (relationshipType: RelationshipType): string => {
  switch (relationshipType) {
    case RelationshipType.IsEmployedBy:
      return 'works for'
    case RelationshipType.Employs:
      return 'employs'
    case RelationshipType.Introduced:
      return 'introduced'
    case RelationshipType.WasIntroducedBy:
      return 'was introduced by'
    case RelationshipType.IsAffiliatedWith:
      return 'is affilated with'
    case RelationshipType.IsParentCompanyOf:
      return 'is parent company of'
    case RelationshipType.IsSubOrgOf:
      return 'is a sub-org of'
  }
}

export const parentRelationshipMap: { [key in AccountRelationshipType]: RelationshipType } = {
  [AccountRelationshipType.Employs]: RelationshipType.Employs,
  [AccountRelationshipType.AffiliatedWith]: RelationshipType.IsAffiliatedWith,
  [AccountRelationshipType.ChildCompanyOf]: RelationshipType.IsParentCompanyOf,
  [AccountRelationshipType.Introduced]: RelationshipType.Introduced,
}

export const childRelationshipMap: { [key in AccountRelationshipType]: RelationshipType } = {
  [AccountRelationshipType.Employs]: RelationshipType.IsEmployedBy,
  [AccountRelationshipType.Introduced]: RelationshipType.WasIntroducedBy,
  [AccountRelationshipType.ChildCompanyOf]: RelationshipType.IsSubOrgOf,
  [AccountRelationshipType.AffiliatedWith]: RelationshipType.IsAffiliatedWith,
}
